<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-03-08 11:58:40
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-09-24 11:15:09
 * @FilePath: \front\src\views\FindPatientCommon\components\tables.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="about">
        <div class="collapse-wrap">
			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
                    <el-table-column v-for="(item,index) in tableColumn[queryType][childType]" :key="index" :prop="item.prop" :label="item.label" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span :style="{ color: (scope.row.recordState == 10 || scope.row.schedulingState == 10) && (item.prop === 'recordStateStr' || item.prop === 'schedulingStateStr') ? '#ff0000' : '#606266' }">
                            {{ item.prop === 'bindingStatus' ? (scope.row.bindingStatus === 1 ? '已绑定' : '未绑定') : scope.row[item.prop] }}
                            </span>
                        </template>
                    </el-table-column>

					<el-table-column fixed="right" label="操作" width="220" v-if="childType=='captured'">
						<template slot-scope="scope">
							<div class="tab-action" >
                                <template v-if="queryType==0">
                                    <el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3,  fid: scope.row.id,datasources:scope.row.datasources}}"><i class="icon-research"></i></router-link></el-tooltip>
                                    <el-tooltip v-if="scope.row.recordState==10 && permission" content="分配医生" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg2(scope.row)"></i></el-tooltip>
                                    <el-tooltip v-if="scope.row.recordState!=10 && permission" content="修改医生" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg2(scope.row)"></i></el-tooltip>
									<el-tooltip v-if="scope.row.recordState==0" content="分配疾病管理师" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg(scope.row)"></i></el-tooltip>

                                    <el-tooltip v-if="scope.row.recordState==1" content="修改疾病管理师" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg(scope.row)"></i></el-tooltip>	

                                    <!-- <el-popconfirm  confirmButtonText='确定' title="确定回退到待分配吗？" @confirm="saveForm3(scope.row)"> -->
                                    <el-tooltip content="回退" slot="reference" placement="top" :enterable="false">
                                        <i class="icon-sync" v-if="scope.row.recordState!==0 && scope.row.recordState!=10" @click="openModal(scope.row)"></i>
                                    </el-tooltip>
                                    <!-- </el-popconfirm> -->
                                    <el-popconfirm v-if="scope.row.recordState==0||scope.row.recordState==1" confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm2(scope.row)">
                                        <el-tooltip content="勿访" slot="reference" placement="top" :enterable="false"><i class="icon-wufan"></i></el-tooltip>
                                    </el-popconfirm>
                                    <el-tooltip content="删除" slot="reference" placement="top" :enterable="false" ><i class="el-icon-delete" @click="openDelete(scope.row)"></i></el-tooltip>
                                </template>
                                <template v-if="queryType==2||queryType==1">
                                    <el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2,id:scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
                                    <el-tooltip v-if="scope.row.schedulingState==10 && permission" content="分配医生" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg2(scope.row)"></i></el-tooltip>
                                    <el-tooltip v-if="scope.row.schedulingState!=10 && permission" content="修改医生" placement="top" :enterable="false"><i class="icon-assigning" @click="showDlg2(scope.row)"></i></el-tooltip>
									<el-popconfirm v-if="scope.row.schedulingState==1||scope.row.schedulingState ==5 && scope.row.schedulingState!==10 " confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm21(scope.row)">
                                        <el-tooltip content="勿访" slot="reference" placement="top" :enterable="false"><i class="icon-wufan"></i></el-tooltip>
                                    </el-popconfirm>
                                    <el-popconfirm confirmButtonText='确定' title="确定回退到待排期吗？" @confirm="saveForm22(scope.row)" v-if="scope.row.schedulingState == 2||scope.row.schedulingState == 3||scope.row.schedulingState >5 && scope.row.schedulingState!=10">
                                        <el-tooltip content="回退" slot="reference" placement="top" :enterable="false" ><i class="icon-sync"></i></el-tooltip>
                                    </el-popconfirm>
                                    <el-tooltip content="删除" slot="reference" placement="top" :enterable="false" ><i class="el-icon-delete"  @click="openDelete(scope.row)"></i></el-tooltip>
                                </template>
                                <template v-if="queryType==4">
                                    <el-tooltip v-if="scope.row.followupState=='1'||scope.row.followupState=='3'" content="随访" placement="top" :enterable="false"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t:5, date: scope.row.date}}"><i class="icon-follow"></i></router-link></el-tooltip>
                                    <el-tooltip  v-if="scope.row.followupState=='1'||scope.row.followupState=='3'" content="终止随访" placement="top" :enterable="false"><i class="icon-wufan" @click="showDlg1(1, scope.row)"></i></el-tooltip>

                                    <el-tooltip  v-if="scope.row.followupState=='2'||scope.row.followupState=='4'" content="查看" placement="top" :enterable="false"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t:5, date: scope.row.date, followupId:scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>

                                    <el-popconfirm  v-if="scope.row.followupState=='4'||(scope.row.followupState=='2'&&followPermission)" confirmButtonText='确定' :title="`确定回退到${scope.row.followupState=='4'?'待随访':scope.row.followupState=='2'?'暂存':''}吗？`" @confirm="saveForm42(scope.row)">
									<el-tooltip content="回退" slot="reference" placement="top" :enterable="false"><i class="icon-sync"></i></el-tooltip>
								</el-popconfirm>
                                </template>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
                    <el-row v-if="childType=='captured'">
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
					<el-row v-else>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter1.pageNumber-1)*filter1.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter1.pageNumber - 1) * filter1.pageSize + filter1.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter1.pageSize" :total="list.total" @size-change="handleSizeChange1" @current-change="handleCurrentChange1"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>	
		</div>
        <el-dialog title="分配疾病管理师" width="530px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="疾病管理师" prop="diseaseManagerId">
					<el-select size="small" filterable clearable placeholder="请选择" v-model="form.diseaseManagerId">
						<el-option v-for="item in managerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm1">保 存</el-button>
			</div>
		</el-dialog>

        <el-dialog title="终止随访" width="560px" :visible.sync="dlg1.active" :close-on-click-modal="false">
			<el-form ref="form1" label-width="120px" :rules="dlg1.rules" :model="form1">
				<el-form-item label="终止随访类型" prop="stopType">
					<el-radio-group v-model="form1.stopType">
						<el-radio :label="1">单次终止</el-radio>
						<el-radio :label="2">全部终止</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="终止随访原因" prop="stopReason">
					<el-radio-group v-model="form1.stopReason">
						<el-radio label="患者已住院">患者已住院</el-radio>
						<el-radio label="患者死亡">患者死亡</el-radio>
						<el-radio label="无法联系到患者">无法联系到患者</el-radio>
						<el-radio label="other">其他原因</el-radio>
						<el-input size="mini" placeholder="输入其他原因" style="width: 250px;" v-model="form1.otherReason" v-if="form1.stopReason == 'other'"></el-input>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm41">保 存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分配医生" width="530px" :visible.sync="dlg2.active" :close-on-click-modal="false" >
			<el-form ref="form" label-width="120px" :rules="dlg2.rules" :model="form">
				<el-form-item label="医生" prop="doctorId">
					<el-select size="small" filterable clearable placeholder="请选择" v-model="form.doctorId">
						<el-option v-for="item in doctorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button v-if="queryType==0" type="primary" :loading="isLoading" @click="saveForm1">保 存</el-button>
				<el-button v-if="queryType==2||queryType==1" type="primary" :loading="isLoading" @click="saveForm21">保 存</el-button>
			</div>
		</el-dialog>
		<BackModal v-if="backdata.active" :backdata="backdata" @closeDlg="closeDlg"/>
        
        <el-dialog title="确认删除" width="600px" :visible.sync="showDelete" :close-on-click-modal="false" class='cenDialog'>
			<div>
                <p style="text-align: left;">
                    是否删除就诊记录及关联数据？删除后将无法恢复，请谨慎操作！<br/>
                    如确认删除，请在下方输入<b style="color:#FD0A0A">“确认删除”</b>，完成验证
                </p>
                        <el-input
                            v-model="confirmText"
                            size="small"
                            maxlength="6"
                            placeholder="请输入“确认删除”"
                            @paste.native.prevent
                        />
            </div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button  type="danger" :loading="isLoading" @click="deleteHandle">确认删除</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>

import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import { EventBus } from '@/event-bus.js';
import BackModal from '../../Hospital/components/backModal.vue'

export default {
    // mixins: [mixin],
    components: {
		BackModal
		},
    props: {
       
        childType:{
            required: true,
        }
    },
    data(){
        return{
            list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: []
			},
            filter: {
                pageNumber: 1,
				pageSize: 10,
                showMyself:false
            },
            filter1:{
                cardNum:'',
                dataDateEnd:'',
                dataDateStart:'',
                dataType:null,
                departmentId:null,
                hisId:'',
                hisPid:'',
                admissionNumber:'',
                name:'',
                pageNumber:1,
                pageSize:10,
            },
            tableColumn: {
                0:{
                    'captured':[
                        {
                            label:'姓名',
                            prop:'name',
                        },
						{
							label:'科室',
							prop:'inHospitalDepartment',
						},
                        {
							label:'住院号',
							prop:'admissionNumber',
                        },
                        {
							label:'入院诊断',
							prop:'inHospitalDiagnosis',
                        },
						{
							label:'床号',
							prop:'hospitalBed',
						},
                        {
                            label:'入院时间',
                            prop:'inHospitalDate',
                        },
                        {
                            label:'责任医生',
                            prop:'mainDoctor',
                        },
                        {
                            label:'疾病管理师',
                            prop:'diseaseManager',
                        },
                        {
                            label:'管理状态',
                            prop:'recordStateStr',
                        }
                    ],
                    'notCaptured':[
                    {
                            label:'姓名',
                            prop:'name',
                        },
                        {
                            label:'住院号',
                            prop:'admissionNumber',
                        },
                        {
                            label:'科室',
                            prop:'department',
                        },
                        {
                            label:'入院时间',
                            prop:'dataDate',
                        },
                        {
                            label:'错误信息',
                            prop:'errorReason',
                        },
                        {
                            label:'处理方法',
                            prop:'solution',
                        },
                    ]
                },
                2:{
                    'captured':[
                        {
                            label:'姓名',
                            prop:'name',
                        },
                        {
							label:'住院号',
							prop:'admissionNumber',
                        },
                        {
                            label:'科室',
                            prop:'outHospitalDepartment',
                        },
                        {
                            label:'出院时间',
                            prop:'outHospitalCloseDate',
                        },
                        {
                            label:'责任医生',
                            prop:'docName',
                        },
                        {
                            label:'出院诊断',
                            prop:'outHospitalDiagnosisName',
                        },
                        {
                            label:'排期状态',
                            prop:'schedulingStateStr',
                        }
                    ],
                    'notCaptured':[
                    {
                            label:'姓名',
                            prop:'name',
                        },
                        {
                            label:'身份证号',
                            prop:'cardNum',
                        },
                        {
                            label:'科室',
                            prop:'department',
                        },
                        {
                            label:'出院时间',
                            prop:'dataDate',
                        },
                        {
                            label:'错误信息',
                            prop:'errorReason',
                        },
                        {
                            label:'处理方法',
                            prop:'solution',
                        },
                    ]
                },
                1:{
                    'captured':[
                        {
                            label:'姓名',
                            prop:'name',
                        },
                        {
							label:'就诊号',
							prop:'admissionNumber',
                        },
                        {
                            label:'科室',
                            prop:'outHospitalDepartment',
                        },
                        {
                            label:'就诊时间',
                            prop:'outHospitalCloseDate',
                        },
                        {
                            label:'责任医生',
                            prop:'docName',
                        },
                        {
                            label:'门诊诊断',
                            prop:'outHospitalDiagnosisName',
                        },
                        {
                            label:'排期状态',
                            prop:'schedulingStateStr',
                        }
                    ],
                    'notCaptured':[
                    {
                            label:'姓名',
                            prop:'name',
                        },
                        {
                            label:'身份证号',
                            prop:'cardNum',
                        },
                        {
                            label:'科室',
                            prop:'department',
                        },
                        {
                            label:'就诊时间',
                            prop:'dataDate',
                        },
                        {
                            label:'错误信息',
                            prop:'errorReason',
                        },
                        {
                            label:'处理方法',
                            prop:'solution',
                        },
                    ]
                },
                4:{
                    'captured':[
                        {
                            label:'姓名',
                            prop:'name',
                        },
                        {
                            label:'住院号',
                            prop:'admissionNumber',
                        },
                        {
                            label:'科室',
                            prop:'departmentName',
                        },
                        {
                            label:'出院时间',
                            prop:'outTimeDate',
                        },
                        {
                            label:'应随访时间',
                            prop:'expectFollowupDate',
                        },
                        {
                            label:'随访次数',
                            prop:'followupNum',
                        },
                        {
                            label:'诊断',
                            prop:'outHospitalDiagnosisName',
                        },
                        {
                            label:'管理状态',
                            prop:'followupStateStr',
                        },
                        {
                            label:'小程序绑定',
                            prop:'bindingStatus',
                        }
                    ],
                }
            },
            isLoading:false,
			permission: false,
            dlg: {
				active: false,
				rules: {
					diseaseManagerId: {required: true, message: '请选择疾病管理师'}
				}
			},
			dlg2: {
				active: false,
				rules: {
					doctorId: {required: true, message: '请选择医生'}
				}
			},
            form: {
				id: 0,
				diseaseManager: '',
				diseaseManagerId: '',
				ids: [],
				recordState: 0,
				doctor: '',
				doctorId: '',
			},
			managerList: [],
			doctorList: [],
            dlg1: {
				active: false,
				rules: {
					stopType: {required: true, message: '请选择'},
					stopReason: {required: true, message: '请选择'},
				}
			},
			form1: {id: 0, stopType: '', stopReason: '', otherReason: ''},
            queryType:9,
            backdata:{
				active: false,
				data:{},
				type:2
			},
            showDelete:false,
            itemData:{},
            confirmText:'',
        }
    },
    created() {
        let query = this.$route.query;
        this.queryType=Number(query.dataType)
        this.filter={
            ...this.filter,
            ...query
        }
        this.filter1={
            ...this.filter1,
            ...query
        }
      
        this.filterEvent(this.filter)
        this.$watch(
            () => this.$route.query, // 监听的对象是 $route.query
            (newQuery, oldQuery) => {
				this.queryType=newQuery.dataType;

                // this.list={current: 1,
				// total: 0,
				// pageSize: 0,
				// data:[]}
                EventBus.$on('update-filter',(newVal) => {
                    this.filter=newVal;
                    this.filter.pageSize=10;
                    this.filter.pageNumber=1;
                    // this.filter.dataType=this.queryType;
                    // this.filter.cardNum=newVal.cardNum;
                    // this.filter.admissionNumber=newVal.admissionNumber;
                    // this.filter.departmentId=newVal.inHospitalDepartmentId||newVal.outHospitalDepartmentId||newVal.hospitalDepartmentIds;
                    // this.filter.name=newVal.name;
                    this.filterEvent(newVal)
                })
            }
        );
        if(this.queryType==0){
            // 获取 疾病管理师下拉
            api.getComboboxUserList({roleId: 3}).then((res)=>{
                if (res.code == 1000 && res.data) {
                    this.managerList = res.data;
                }
            })
        }
		// 分配医生权限
		this.user = JSON.parse(localStorage.getItem('user')).data;
		this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "5") ? true : false;
		this.followPermission=(this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "7") ? true : false;
    },

    mounted() {
		EventBus.$on('update-filter',(newVal) => {
            // console.log(newVal,'==333333333')
            this.filter=newVal;
            this.filter.pageSize=10;
            this.filter1.dataType=this.queryType;
            this.filter1.cardNum=newVal.cardNum;
            this.filter1.admissionNumber=newVal.admissionNumber;
            this.filter1.departmentId=newVal.inHospitalDepartmentId||newVal.outHospitalDepartmentId||newVal.hospitalDepartmentIds;
            this.filter1.name=newVal.name;
            this.filterEvent(newVal)
        })
    },
    destroyed(){
        EventBus.$off('update-filter');
    },
    methods:{
        filterEvent(filter){
            if(filter.name||filter.cardNum||filter.admissionNumber||(filter.date&&filter.date.length>0)||filter.inHospitalDepartmentId||filter.outHospitalDepartmentId||filter.hospitalDepartmentIds||(filter.date1&&filter.date1.length>0)){
				this.loadList();
			}else{
                this.list={
                    current: 1,
                    total: 0,
                    pageSize: 0,
                    data: []
                }
            }
        },
        dateHandle(filter){
            if(filter.date&&filter.date.length>0){
                this.filter1.dataDateStart = dayjs(filter.date[0]).format('YYYY-MM-DD 00:00:00');
				this.filter1.dataDateEnd = dayjs(filter.date[1]).format('YYYY-MM-DD 23:59:59');
            }else{
                this.filter1.dataDateStart = '';
				this.filter1.dataDateEnd = '';		
            }
        },
        async loadList(){
            if (this.isLoading) {
                return false;
            }
            this.dateHandle(this.filter);
			// 已抓取
			this.isLoading = true;
            let res;
            let query = this.$route.query;
            this.queryType=Number(query.dataType)
            if(this.childType=='captured'){
                switch (this.queryType) {
                    case 0:
                        res = await api.getHospitalPatientList(this.filter);
                        break;
                    case 2:  case 1:
                        res = await api.getScheduleList(this.filter);
                        break;
                    case 4:
                        res = await api.getFollowList(this.filter);
                        break;
                }
            }else if(this.childType=='notCaptured'&&this.queryType!==4){
                res = await api.getListErrorNewMsg(this.filter1);
            }
			if (res?.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            if (res.data) {
				res.data.forEach((item)=>{
                    if(this.childType=='captured'){
                        switch(this.queryType){
                            case 0:
                                item.inHospitalDate = dayjs(item.inHospitalDate).format('YYYY-MM-DD HH:mm:ss');
                                break;
                            case 2: case 1:
                                item.outHospitalCloseDate = dayjs(item.outHospitalCloseDate).format('YYYY-MM-DD HH:mm:ss');
                                break;
                            case 4:
                                item.outTimeDate = dayjs(item.outTimeDate).format('YYYY-MM-DD HH:mm:ss');
                                item.date = dayjs(item.expectFollowupDate).format('YYYY-MM-DD');
                        }
                    }else if(this.childType=='notCaptured'){
                        item.dataDate = dayjs(item.dataDate).format('YYYY-MM-DD HH:mm:ss');
                    }
                    if(item.cardNum)item.cardNum = utils.hideIdCard(item.cardNum);
					

				})
				this.list.data = res.data;
            }
			// 未抓取
			this.isLoading = false;
		},
        handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
        handleSizeChange1(v) {
			this.filter1.pageSize = v;
			this.filter1.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange1(v) {
			this.filter1.pageNumber = v;
			this.loadList();
		},
        openModal(item){
            switch(item.recordState){
                case 1:
                    this.backdata.type=2;
                    break;
                case 2:
                    this.backdata.type=3;
                    break;
                case 3:
                    this.backdata.type=4;
                    break;
                case 4:
                    this.backdata.type=5;
                    break;
            }
			this.backdata.active=true;
			this.backdata.data=item;
        
		},
        showDlg(item) {
				this.dlg.active = true;
				this.form.id = +item.ihdId;//分配要用院中id
				this.form.diseaseManagerId = item.diseaseManagerId || '';
		},
		// 分配医生弹窗
		async showDlg2(item) {
				// 获取 医生下拉
				await api.getComboboxUserList({roleId: 2,depIds:item.inHospitalDepartmentId}).then((res)=>{
					if (res.code == 1000 && res.data) {
						this.doctorList = res.data;
					}
				})
				
				this.dlg2.active = true;
				
				if(this.queryType == 0){
					// 院中
					this.form.id = +item.ihdId;//分配要用院中id
					this.form.recordState = item.recordState;
					this.form.doctorId = item.mainDoctorId || '';
				}else{
					// 出院、门诊
					this.form.detailId = +item.id;
					this.form.datasources = item.datasources;
					this.form.schedulingState = item.schedulingState;
					this.form.doctorId = item.docId || '';
				}

		},
        // 院中分配疾病管理师/医生
        async saveForm1() {
			let res;
			// 分配
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					if(this.dlg2.active){
						// 如果是分配医生弹窗显示,则按照分配医生处理
						let doctor = this.doctorList.find((item)=>{if (item.id == this.form.doctorId) { return item;}});
						this.form.doctor = doctor.name;
						this.form.recordState = this.form.recordState == 10 ? 0 : this.form.recordState;
					}else{
						let diseaseManager = this.managerList.find((item)=>{if (item.id == this.form.diseaseManagerId) { return item;}});
						this.form.diseaseManager = diseaseManager.name;
						this.form.recordState = 1;
					}
					if (this.form.id > 0) {
						this.form.ids = this.form.id;
					}
					this.isLoading = true;
					res = await api.updateHospitalPatientState(this.form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.closeDlg();
					this.$message.success('保存成功');
					this.loadList();
				}
			})	
		},
        // 院中勿访
        async saveForm2(item) {
			let res;
			this.form.diseaseManager = '';
			this.form.diseaseManagerId = '';
			this.form.recordState = 4;
			if (item && item.id > 0) {
				this.form.ids = item.ihdId;//要用院中id
			}
			this.isLoading = true;
			res = await api.updateHospitalPatientState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.closeDlg();
			this.$message.success('保存成功');
			this.loadList();
		},
        closeDlg(data) {
			this.dlg.active = false;
			this.dlg1.active = false;
			this.dlg2.active = false;
            this.showDelete=false;
            this.confirmText='';
            this.itemData={};
            // 回退
            this.backdata={
				active: false,
				data:{},
				type:2
			}
			if(data&&data=='sucess'){
				this.loadList();
			}
		},
        // 院中回退
        async saveForm3(item) {
			// 回退
			let res;
			this.isLoading = true;
			res = await api.rollbackrecordState({ihdid:item.ihdId});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},
        //出院/门诊-勿访/分配医生
        async saveForm21(item) {
			console.log(item)
			let res;
			if (item && item.id > 0) {
				this.form.detailId = item.id;
				this.form.datasources = item.datasources;
				
			}
			this.isLoading = true;
			
			if(this.dlg2.active){
				// 如果是分配医生弹窗显示,则按照分配医生处理
				let doctor = this.doctorList.find((item)=>{if (item.id == this.form.doctorId) { return item;}});
				this.form.doctor = doctor.name;
				this.form.schedulingState = this.form.schedulingState == 10 ? 1 : this.form.schedulingState;
			}else{
				// 勿访
				this.form.schedulingState = item.schedulingState == 1 ? 3 : 7; // 如果是1待排期，就变成3勿访，否则是7过期勿访
			}
			
			console.log(this.form)
			
			res = await api.updateScheduleState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.closeDlg();
			this.loadList();
		},// 回退
		async saveForm22(item) {
			let res;
			this.form.detailId = item.id;
			this.form.datasources = item.datasources;
			this.form.schedulingState = item.schedulingState;

			this.isLoading = true;
			res = await api.rollbackScheduleState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},
        // 随访
        showDlg1(v, item) {
			this.dlg1.active = true;
			this.$nextTick(()=>{
				this.$refs['form1'].resetFields();
				this.form1.id = item.id;
			});			
		},
		// 终止随访
		async saveForm41() {
			this.$refs['form1'].validate(async (valid)=>{
				if (valid) {
					let form = JSON.parse(JSON.stringify(this.form1));
					if (form.stopReason == 'other') {form.stopReason = form.otherReason;}
					if (form.stopReason == '') {return this.$message.warning('请输入终止原因')}
					this.isLoading = true;
					let res = await api.stopFollow(form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.closeDlg();
					this.loadList();
				}
			})
		},
        // 回退
		async saveForm42(item) {
       
			let res;
			this.form1.followupId = item.id;
            if(item.followupState==2){
                this.form1.followupState = 3;
            }else if(item.followupState==4){
                this.form1.followupState = 1;
                
            }
			this.isLoading = true;
			res = await api.rollbackFollowState(this.form1);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},
        //delete弹窗
        openDelete(item) {
            this.showDelete = true;
            this.itemData=item
        },
        // 删除
        async deleteHandle() {

            if (this.confirmText==='确认删除') {
            
                let res;
                if(this.queryType==0){
                    res= await api.inhospitalRemove({id:this.itemData.ihdId});
                }else if(this.queryType==1||this.queryType==2){
                    res= await api.outhospitalRemove({datasources:this.queryType,detailId:this.itemData.id});
                }
                if(res.code==1000){
                    this.$message.success('删除成功');
                    this.closeDlg()
                }else {
                    this.$message.error(res.message);
                }
                this.loadList();

            } else {
                this.$message.error('请输入“确认删除”');
            }



        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
@import '@/assets/style/common.less';

.cenDialog{
    text-align: center;
   ::v-deep .el-input{
        width:100% !important;
    }
}
.collapse-wrap{
	margin-top: 20px;
	h1{
		font-size: 18px;
		font-weight: 350;
		color: #616161;
		margin: 0 0 20px;
	}
    .table-wrap{
        padding:0;
    }
}
</style>